import { FC, useCallback, useContext, useEffect, useMemo, useState } from "react";
import styles from "./styles.module.scss";
import { Breadcrumb, Notification } from "@douyinfe/semi-ui";
import Link from "next/link";
import { useRouter } from "next/router";
import { NavType } from "../navbar";
import cName from "classnames";
import { IconChevronRight } from '@douyinfe/semi-icons';
import axios from 'axios';
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import { IndexContext } from "@/stores";
import classNames from "classnames";
import { PageNormal } from "./page_normal";
import { PageCrumb } from "./page_crumb";
// import PageCrumb from "./page_crumb/index_copy";

type CrumbType = {
  path: string,
  name: string,
}

export interface ILayoutProps {
  crumb?: CrumbType[],
  backgroundColor?: string;
  banner?: string;
  hasVideo?: boolean;
  title?: JSX.Element;
  temp?: string;
  partPath?: string | undefined | null;
}


export const PageLayout: FC<ILayoutProps & { children: JSX.Element }> = ({
  children,
  crumb = [],
  backgroundColor = '',
  banner = '/image/page-banner.png',
  hasVideo = false,
  title = (
    <>
      <h1 style={{ fontSize: '36px' }}>IPB 2027 第二十四届国际粉体、散料、流体加工展览会</h1>
      <p style={{ fontSize: '24px', fontWeight: 'normal' }}>2027年8月2-4日</p>
      <p style={{ fontSize: '24px', fontWeight: 'normal' }}>上海世博展览馆</p>
    </>
  ),
  temp = "page_normal",
  partPath
}) => {
  const temps = {
    'page_normal': <PageNormal
      {...{ hasVideo, banner, title }}
    />,
    'page_crumb': <PageCrumb
      {...{ hasVideo, banner, crumb, partPath }}
    />
  } as any

  return (
    <div className={styles.page} style={{ backgroundColor }}>
      {temps[temp]}

      <div className={cName([styles.content, 'content'])}>
        <div>
          <div style={{ width: '100%' }}>
            {children}
          </div>
        </div>
        {/* <MyModal visible={visible} onOk={() => setVisible(false)}></MyModal> */}
      </div>
      <style jsx global>
        {
          `
            .semi-navigation{
              border:none !important;
              padding:0 !important;
            }
            .semi-navigation-header-text{
              width:100%;
            }
            .semi-navigation-header{
              padding:0 !important;
              margin-top:40px;
            }
            .semi-navigation-item{
              height:auto !important;
              padding: 0 12px !important;
            }
            .semi-navigation-item-text{
              display:block;
              width:100%;
            }
            .semi-navigation-footer{
              position: absolute;
              top: 0;
              left: 20%;
            }
            .semi-navigation-list-wrapper{
              height: auto !important;
              padding:0 !important;
              margin:10px 0;
            }
            .semi-breadcrumb-item-active span{
              color: #6354a2 !important; 
              // font-weight:500;
            }
            .semi-navigation-collapsed{
              height:70px !important;
            }
            .semi-breadcrumb-item-link:hover{
              color: #808080;
            }
            .semi-notification-notice{
              min-width: '200px'
            }
            .semi-breadcrumb-item-wrap{
              margin: 4px 6px;
            }
          `
        }
      </style>
    </div>
  );
};
